export default "__VITE_ASSET__DinOjjqr__"